import alphabetically from './alphabetically';

const sortArray = {
	alphabetically: alphabetically
}

export default sortArray;
